import { formatInTimeZone } from 'date-fns-tz';
import addDays from 'date-fns/addDays';
import type { Release, FullCalendarItemInput } from '../../types';

export const transformData = (releases: (Release | undefined)[]): FullCalendarItemInput[] =>
	releases
		.filter((release) => release?.releaseDate)
		.map((release) => {
			const endDate = addDays(new Date(release?.releaseDate ?? ''), 1);
			return {
				allDay: true,
				title: release?.name,
				start: formatInTimeZone(release?.releaseDate ?? '', 'UTC', 'yyyy-MM-dd'),
				end: formatInTimeZone(endDate, 'UTC', 'yyyy-MM-dd'),
				editable: false,
				extendedProps: { release },
			};
		});
